<div class="app-shell app-page-wrapper">
	<div class="app-main-layout">
		<div class="app-side-panel" *ngIf="themeBuilder.isOpen">
			<theme-builder></theme-builder>
		</div>
		<!-- 	Main app page wrapper content -->
		<div class="app-main-content">
			<router-outlet />
		</div>
	</div>
</div>